import useTranslation from "@babackapp/translations/use-translation";
import { DateRangePicker } from "@babackapp/ui/components/date-range-picker";
import { Suspense, useState } from "react";
import ReturnOperationsDashboard from "./components/return-operations-dashboard";
import {
  INITIAL_DASHBOARD_FILTERS,
  DashboardFiltersProvider,
} from "../home/lib/dashboard-filters";

export default function OperationalDashboard() {
  const t = useTranslation();
  const [filters, setFilters] = useState(INITIAL_DASHBOARD_FILTERS);

  return (
    <DashboardFiltersProvider value={filters}>
      <div className="flex items-center justify-center">
        <div className="grid grid-cols-4 gap-4 w-full max-w-[1600px] lg:px-16 lg:py-12 px-6 py-6">
          <div className="flex justify-between items-center gap-2 w-full">
            <div>
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                {t("operationsDashboard.title")}
              </h3>
              <p className="text-sm leading-relaxed text-muted-foreground max-w-[500px]">
                {t("operationsDashboard.subtitle")}
              </p>
            </div>
          </div>

          <div className="col-span-4 flex justify-end">
            <div>
              <DateRangePicker
                range={{
                  from: filters.fromTimestamp ?? 0,
                  to: filters.toTimestamp,
                }}
                onSelect={(range) => {
                  if (range.from && range.to) {
                    setFilters((old) => ({
                      ...old,
                      fromTimestamp: range.from,
                      toTimestamp: range.to,
                    }));
                  }
                }}
              />
            </div>
          </div>
          <Suspense>
            <ReturnOperationsDashboard />
          </Suspense>
        </div>
      </div>
    </DashboardFiltersProvider>
  );
}
